import {
    TabsSlice,
    ActiveMainTabSlice,
    collapsedSideMenu,
} from "./TabsSlice";
import {LoginSlice} from "./Login";
import {MobileSidebarSlice} from "./MobileSidebar";
import {CompanySlice} from "./companySlice";
import {ProductsSlice} from "./DataPanel/Products/productsSlice";
import {ProductCategorySlice} from "./DataPanel/Products/productCategorySlice";
import {SearchTableSlice} from "./SearchTableSlice";
import {NavbarSlice} from "./Navbar";
import {ActivitySlice} from "./activitySlice";
import {SettingsSlice} from "./settingsSlice";
import {ClientsSlice} from "./DataPanel/Clients/clientSlice";
import {SuppliersSlice} from "./DataPanel/Suppliers/supplierSlice";
import {CashSlice} from "./DataPanel/Cash/cashSlice";
import {SalesSettingsSlice} from "./DataPanel/Sales/salesSettingsSlice";
import {SalesSlice} from "./DataPanel/Sales/salesSlice";
import {BuysSlice} from "./DataPanel/Buys/buysSlice";
import {BuysSettingsSlice} from "./DataPanel/Buys/buysSettingsSlice";
import {AccountingSlice} from "./DataPanel/Accounting/accountingSlice";
import {SubscriptionsSlice} from "./subscriptionsSlice";
import {CRMSlice} from "./crmSlice";
import {PayrollSlice} from "./DataPanel/Payroll/payrollSlice";
import {CloudSlice} from "./cloudSlice";
import {PrescriptionSlice} from "./DataPanel/Prescription/prescriptionSlice";
import {DclSlice} from "./DataPanel/Dcl/dclSlice";
import {FixedAssetsSlice} from "./DataPanel/FixedAssets/fixedAssetsSlice";
import {AISlice} from "./aiSlice";
import {TransfersSlice} from "./DataPanel/Sales/transfersSlice";

const rootReducer = {
    ACTIVE_PATH: NavbarSlice.reducer,
    ACTIVE_MAIN_TAB: ActiveMainTabSlice.reducer,
    ACTIVITY: ActivitySlice.reducer,
    ACCOUNTING_DATA: AccountingSlice.reducer,
    AI: AISlice.reducer,

    BUYS: BuysSlice.reducer,
    BUYS_SETTINGS: BuysSettingsSlice.reducer,

    CLOUD: CloudSlice.reducer,
    CRM: CRMSlice.reducer,
    CASH_DATA: CashSlice.reducer,
    CLIENTS_DATA: ClientsSlice.reducer,
    COLLAPSED_SIDE_MENU: collapsedSideMenu.reducer,
    COMPANY_DATA: CompanySlice.reducer,

    DCL: DclSlice.reducer,

    FIXED_ASSETS: FixedAssetsSlice.reducer,

    LOGIN_STATE: LoginSlice.reducer,

    MOBILE_SIDEBAR_TOGGLE: MobileSidebarSlice.reducer,

    PRODUCTS_CATEGORY: ProductCategorySlice.reducer,
    PAYROLL: PayrollSlice.reducer,
    PRESCRIPTION: PrescriptionSlice.reducer,
    PRODUCTS_DATA: ProductsSlice.reducer,

    SUPPLIERS_DATA: SuppliersSlice.reducer,
    SEARCH_TABLE: SearchTableSlice.reducer,
    SETTINGS: SettingsSlice.reducer,
    SALES: SalesSlice.reducer,
    SALES_SETTINGS: SalesSettingsSlice.reducer,
    SUBSCRIPTIONS: SubscriptionsSlice.reducer,

    TRANSFERS: TransfersSlice.reducer,
    TABS_REDUCER: TabsSlice.reducer,
}

export default rootReducer;
